<template>
    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Add User" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form ref="userForm">
                <v-text-field color="primary" type="text" label="Name" id="name" name="name" v-model="newUser.name"
                    required :rules="nameRules"></v-text-field>
                <v-text-field color="primary" type="text" label="Email" id="email" name="email" v-model="newUser.email"
                    required :rules="emailRules"></v-text-field>
                <v-text-field color="primary" :type="passwordVisibility ? 'text' : 'password'" label="Password"
                    id="password" name="password" v-model="newUser.password" required :rules="passwordRules"
                    :append-icon="passwordVisibility ? 'mdi-eye' : 'mdi-eye-off'"
                    v-on:click:append="passwordVisibility = !passwordVisibility"></v-text-field>
                <v-select color="primary" label="Rol" id="Rol" name="Rol" :rules="rolRules" v-model="newUser.role_id"
                    required :items="roles" item-value="id" item-title="display_name">
                </v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="validate()" class="w-100" color="primary" variant="elevated" text="Create user"></v-btn>
        </v-card-actions>
    </v-card>

</template>


<script setup>
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { onMounted, ref } from 'vue';
import { emailRules, nameRules, passwordRules, rolRules } from './rules/user';
import { useUserStore } from '@/store/userStore';

const userStore = useUserStore();
const loading = ref(true);
const emit = defineEmits(['close'])

const newUser = ref({
    name: '',
    email: '',
    password: '',
    role_id: ''
});
const userForm = ref();
const roles = ref([]);

onMounted(() => {
    userStore.getRoles().then((res) => {
        roles.value = res.data.data;
        loading.value = false;
    }).catch(error => {
        //NOTIFICAR ERROR
        console.log(error);
        loading.value = false;
    })
})

const validate = async () => {
    const isValid = await userForm.value?.validate();
    if (isValid.valid) {
        loading.value = true;
        try {
            await userStore.createUser(newUser.value);
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación o creación del usuario:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}


const passwordVisibility = ref(false);


</script>